// Ways into the Help Center besides the Help button: a link and a key.

// ?help=<article id> opens that article, ?help=<view> one of these views.
export const HELP_PARAM = "help";
export const HELP_LINK_VIEWS = ["guide", "videos", "whats-new", "ask"];

/** The Help Center target a query string asks for, or null. */
export const readHelpLink = (search = "") => {
   const value = new URLSearchParams(search).get(HELP_PARAM)?.trim();
   return value || null;
};

/** The query string without the help parameter, so a refresh doesn't reopen it. */
export const removeHelpParam = (search = "") => {
   const params = new URLSearchParams(search);
   params.delete(HELP_PARAM);
   const rest = params.toString();
   return rest ? `?${rest}` : "";
};

/**
 * A link that opens the Help Center on `target`. It points at "/" so it works
 * for every role: the app sends "/" on to each role's own home page.
 */
export const buildHelpLink = (target, origin = window.location.origin) =>
   `${origin}/?${HELP_PARAM}=${encodeURIComponent(target)}`;

const TEXT_FIELDS = "input, textarea, select, [contenteditable]:not([contenteditable='false'])";

/** A bare "?" typed anywhere but a text field opens the Help Center. */
export const isHelpShortcut = (event) => {
   if (event.key !== "?" || event.ctrlKey || event.metaKey || event.altKey) return false;
   if (event.defaultPrevented || event.isComposing) return false;
   const target = event.target;
   return !(target instanceof Element && target.closest(TEXT_FIELDS));
};
